import {todoService} from "@/modules/common/services";

const state = {
  todo: {}
};

const getters = {
  todo: state => state.todo
};

const mutations = {
  setTodo: (state, todo) => {
    state.todo = todo;
  }
};

const actions = {
  fetchTodo : async ({commit}, payload) => {
    try {
      const todo = await todoService.getTodo()
      commit('setTodo',todo )
    } catch (e) {
      console.log("setTodo", e)
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
